import React from 'react';
import {IconProps} from './IconProps';

export default function IconGoogle({className, height = '1em'}: IconProps) {
  return (
    <svg height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="2" y="2" width="16" height="16">
        <path
          d="M17.25 10.1875C17.25 9.6875 17.1875 9.3125 17.125 8.90625H9.75V11.5625H14.125C13.9688 12.7188 12.8125 14.9062 9.75 14.9062C7.09375 14.9062 4.9375 12.7188 4.9375 10C4.9375 5.65625 10.0625 3.65625 12.8125 6.3125L14.9375 4.28125C13.5938 3.03125 11.8125 2.25 9.75 2.25C5.4375 2.25 2 5.71875 2 10C2 14.3125 5.4375 17.75 9.75 17.75C14.2188 17.75 17.25 14.625 17.25 10.1875Z"
          fill="#2BA14B"/>
      </mask>
      <g mask="url(#mask0)">
        <rect x="2" y="8" width="16" height="12" fill="#2BA14B"/>
        <path d="M7.5 9.66667L19.5 19V1L7.5 9.66667Z" fill="#3A7CEC"/>
        <path d="M7.5 9.66667L1.5 14V5L7.5 9.66667Z" fill="#F1B500"/>
        <path d="M19.5 3L7.5 9.66667L1.5 5V0.5H19.5V3Z" fill="#E33E2B"/>
      </g>
    </svg>
  );
}
